const year_2018_proportions = {
    0: {
        classroom_teaching_hours: 0,
        classroom_teaching:0,
        break:0,
        non_academic: 0
    },
    1: {
        classroom_teaching_hours: 1,
        classroom_teaching: 45,
        break: 4,
        non_academic: 11
    },
    2: {
        classroom_teaching_hours: 2,
        classroom_teaching: 90,
        break: 8,
        non_academic: 22
    },
    3: {
        classroom_teaching_hours: 3,
        classroom_teaching: 135,
        break: 12,
        non_academic: 33
    },
    4: {
        classroom_teaching_hours: 4,
        classroom_teaching: 180,
        break: 16,
        non_academic: 44
    },
    5: {
        classroom_teaching_hours: 5,
        classroom_teaching: 225,
        break: 20,
        non_academic: 55
    },
    6: {
        classroom_teaching_hours: 6,
        classroom_teaching: 270,
        break: 25,
        non_academic: 65
    },
    7: {
        classroom_teaching_hours: 7,
        classroom_teaching: 315,
        break: 29,
        non_academic: 76
    },
    8: {
        classroom_teaching_hours: 7,
        classroom_teaching: 315,
        break: 33,
        non_academic: 132
    },
    9: {
        classroom_teaching_hours: 8,
        classroom_teaching: 360,
        break: 37,
        non_academic: 143
    },
    10: {
        classroom_teaching_hours: 9,
        classroom_teaching: 405,
        break: 41,
        non_academic: 154
    },
    11: {
        classroom_teaching_hours: 10,
        classroom_teaching: 450,
        break: 45,
        non_academic: 165
    },
    12: {
        classroom_teaching_hours: 11,
        classroom_teaching: 495,
        break: 49,
        non_academic: 176
    },
    13: {
        classroom_teaching_hours: 12,
        classroom_teaching: 540,
        break: 53,
        non_academic: 187
    },
    14: {
        classroom_teaching_hours: 13,
        classroom_teaching: 585,
        break: 57,
        non_academic: 198
    },
    15: {
        classroom_teaching_hours: 14,
        classroom_teaching: 630,
        break: 61,
        non_academic: 209
    },
    16: {
        classroom_teaching_hours: 15,
        classroom_teaching: 675,
        break: 65,
        non_academic: 220
    },
    17: {
        classroom_teaching_hours: 16,
        classroom_teaching: 720,
        break: 70,
        non_academic: 230
    },
    18: {
        classroom_teaching_hours: 17,
        classroom_teaching: 765,
        break: 74,
        non_academic: 241
    },
    19: {
        classroom_teaching_hours: 18,
        classroom_teaching: 810,
        break: 78,
        non_academic: 252
    },
    20: {
        classroom_teaching_hours: 19,
        classroom_teaching: 855,
        break: 82,
        non_academic: 263
    },
    21: {
        classroom_teaching_hours: 20,
        classroom_teaching: 900,
        break: 86,
        non_academic: 274
    },
    22: {
        classroom_teaching_hours: 21,
        classroom_teaching: 945,
        break: 90,
        non_academic: 285
    },
    23: {
        classroom_teaching_hours: 21,
        classroom_teaching: 945,
        break: 94,
        non_academic: 341
    },
    24: {
        classroom_teaching_hours: 22,
        classroom_teaching: 990,
        break: 98,
        non_academic: 352
    },
    25: {
        classroom_teaching_hours: 23,
        classroom_teaching: 1035,
        break: 102,
        non_academic: 363
    },
    26: {
        classroom_teaching_hours: 24,
        classroom_teaching: 1080,
        break: 106,
        non_academic: 374,
    },
    27: {
        classroom_teaching_hours: 25,
        classroom_teaching: 1125,
        break: 110,
        non_academic: 385
    },
    28: {
        classroom_teaching_hours: 26,
        classroom_teaching: 1170,
        break: 115,
        non_academic: 395
    },
    29: {
        classroom_teaching_hours: 27,
        classroom_teaching: 1215,
        break: 119,
        non_academic: 406
    },
    30: {
        classroom_teaching_hours: 28,
        classroom_teaching: 1260,
        break: 123,
        non_academic: 417
    },
    31: {
        classroom_teaching_hours: 29,
        classroom_teaching: 1305,
        break: 127,
        non_academic: 428
    },
    32: {
        classroom_teaching_hours: 30,
        classroom_teaching: 1350,
        break: 131,
        non_academic: 439
    },
    33: {
        classroom_teaching_hours: 31,
        classroom_teaching: 1395,
        break: 135,
        non_academic: 450
    },
    34: {
        classroom_teaching_hours: 32,
        classroom_teaching: 1440,
        break: 139,
        non_academic: 461
    },
    35: {
        classroom_teaching_hours: 33,
        classroom_teaching: 1485,
        break: 143,
        non_academic: 472
    },
    36: {
        classroom_teaching_hours: 34,
        classroom_teaching: 1530,
        break: 147,
        non_academic: 483
    },
    37: {
        classroom_teaching_hours: 34,
        classroom_teaching: 1530,
        break: 151,
        non_academic: 539
    },
    38: {
        classroom_teaching_hours: 35,
        classroom_teaching: 1575,
        break: 155,
        non_academic: 550
    },
    39: {
        classroom_teaching_hours: 36,
        classroom_teaching: 1620,
        break: 160,
        non_academic: 560
    },
    40: {
        classroom_teaching_hours: 37,
        classroom_teaching: 1665,
        break: 164,
        non_academic: 571
    },
    41: {
        classroom_teaching_hours: 38,
        classroom_teaching: 1710,
        break: 168,
        non_academic: 582
    },
    42: {
        classroom_teaching_hours: 39,
        classroom_teaching: 1755,
        break: 172,
        non_academic: 593
    },
    43: {
        classroom_teaching_hours: 40,
        classroom_teaching: 1800,
        break: 176,
        non_academic: 604
    },
    44: {
        classroom_teaching_hours: 41,
        classroom_teaching: 1845,
        break: 180,
        non_academic: 615
    },


}

const year_2018_proportions_new = {
    0: {
        break:0,
        non_academic: 0
    },
    1: {
        break: 4,
        non_academic: 11
    },
    2: {
        break: 8,
        non_academic: 22
    },
    3: {
        break: 12,
        non_academic: 33
    },
    4: {
        break: 16,
        non_academic: 44
    },
    5: {
        break: 20,
        non_academic: 55
    },
    6: {
        break: 25,
        non_academic: 65
    },
    7: {
        break: 29,
        non_academic: 76
    },
    8: {
        break: 37,
        non_academic: 143
    },
    9: {
        break: 41,
        non_academic: 154
    },
    10: {
        break: 45,
        non_academic: 165
    },
    11: {
        break: 49,
        non_academic: 176
    },
    12: {
        break: 53,
        non_academic: 187
    },
    13: {
        break: 57,
        non_academic: 198
    },
    14: {
        break: 61,
        non_academic: 209
    },
    15: {
        break: 65,
        non_academic: 220
    },
    16: {
        break: 70,
        non_academic: 230
    },
    17: {
        break: 74,
        non_academic: 241
    },
    18: {
        break: 78,
        non_academic: 252
    },
    19: {
        break: 82,
        non_academic: 263
    },
    20: {
        break: 86,
        non_academic: 274
    },
    21: {
        break: 90,
        non_academic: 285
    },
    22: {
        break: 98,
        non_academic: 352
    },
    23: {
        break: 102,
        non_academic: 363
    },
    24: {
        break: 106,
        non_academic: 374
    },
    25: {
        break: 110,
        non_academic: 385
    },
    26: {
        break: 115,
        non_academic: 395,
    },
    27: {
        break: 119,
        non_academic: 406
    },
    28: {
        break: 123,
        non_academic: 417
    },
    29: {
        break: 127,
        non_academic: 428
    },
    30: {
        break: 131,
        non_academic: 439
    },
    31: {
        break: 135,
        non_academic: 450
    },
    32: {
        break: 139,
        non_academic: 461
    },
    33: {
        break: 143,
        non_academic: 472
    },
    34: {
        break: 147,
        non_academic: 483
    },
    35: {
        break: 155,
        non_academic: 550
    },
    36: {
        break: 160,
        non_academic: 560
    },
    37: {
        break: 164,
        non_academic: 571
    },
    38: {
        break: 168,
        non_academic: 582
    },
    39: {
        break: 172,
        non_academic: 593
    },
    40: {
        break: 176,
        non_academic: 604
    },
    41: {
        break: 180,
        non_academic: 615
    },

} 

const headship_hours = {
    parvularia: {
        visible: 0,
        payable: 2,
    },
    básica_1_a_4: {
        visible: 0.75,
        payable: 3
    },
    básica_5_a_6: {
        visible: 4.5,
        payable: 4.5
    },
    básica_7_a_8: {
        visible: 6,
        payable: 6
    },
    media: {
        visible: 6,
        payable: 6
    } ,
    none: {
        visible: 0,
        payable: 0
    }
}


export {year_2018_proportions, headship_hours, year_2018_proportions_new}


// WEBPACK FOOTER //
// ./src/components/home/restrictions.js